export const AUDIENCE_COLORS = {
  UTILITY_SCALE: '#0f1740',
  DISTRIBUTED_GENERATION: '#8aa5d1',
  DATA_CENTERS: '#57599c',
  EUROPE: '#407d5e',
  INACTIVE: '#e0e0e0',
} as const
